import { render, staticRenderFns } from "./en-tongji.vue?vue&type=template&id=2aace8a5&scoped=true"
import script from "./en-tongji.vue?vue&type=script&lang=js"
export * from "./en-tongji.vue?vue&type=script&lang=js"
import style0 from "./en-tongji.vue?vue&type=style&index=0&id=2aace8a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aace8a5",
  null
  
)

export default component.exports